import AppRoutes from '../../config/AppRoutes';

export const getIsConstruction = () => {
  const currentUrl = window.location.href.replace(process.env.REACT_APP_URL, '');
  
  return currentUrl === AppRoutes.BUILD_IRQ_COMPARE_PAGE ? 'true' : 'false';
}
